import React, {useEffect} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {useSearch} from '@tanstack/react-router';
import {analytics} from '@resurs-internal/rb-app-api';
import {useTranslate} from 'hooks';
import {BankIDCallbackPage} from '../../../pages/bankid/BankIDCallbackPage';

export const DIRECT_TRANSFER_CALLBACK_PATH = '/direct-transfer/callback';

const FAILED_STATUSES = ['ERROR', 'FAILED', 'CANCELLED', 'EXPIRED'];

export const DepositAccountDirectTransferCallbackPage: React.FC = () => {
  const client = useQueryClient();
  const translate = useTranslate();
  const {accountId, amount, status} = useSearch({
    from: '/_protected/direct-transfer/callback',
  });

  // Aiia does not report the outcome, so assume success unless a status says otherwise.
  const hasFailed = Boolean(
    status && FAILED_STATUSES.includes(status.toUpperCase()),
  );
  const path = `/home/accounts/deposits/${accountId}`;

  useEffect(() => {
    if (hasFailed) return;
    analytics.log('savings_initiate_payment_success');
    client.removeQueries({queryKey: ['accounts', 'deposit']});
    client.removeQueries({queryKey: ['account', 'deposit']});
  }, [client, hasFailed]);

  if (hasFailed) {
    return (
      <BankIDCallbackPage
        variant={'error'}
        title={translate('common.error')}
        subtitle={translate('common.error.subtitle')}
        path={path}
      />
    );
  }

  return (
    <BankIDCallbackPage
      variant={'success'}
      title={translate('savings.deposit.direct.done.title')}
      subtitle={
        amount
          ? translate('savings.deposit.direct.done.body', [amount])
          : undefined
      }
      path={path}
    />
  );
};
